import './NewTestimonials.css';
const testimonials = [
  {
    name: 'Priya Sharma',
    location: 'Madhapur',
    rating: 5,
    text: 'RoomBuddy made my house hunting so easy! The property was exactly as described, and the free packing cartons were a great bonus. Highly recommended!',
    avatar: '👩',
  },
  {
    name: 'Rajesh Kumar',
    location: 'Kondapur',
    rating: 5,
    text: 'Shifting to a new city was stressful, but RoomBuddy handled everything — from finding a verified flat to providing helpers for moving. Amazing service!',
    avatar: '👨',
  },
  {
    name: 'Sneha Reddy',
    location: 'Gachibowli',
    rating: 5,
    text: 'No fake listings, no hidden charges. The field executive showed me the property in detail before I finalized. Truly transparent and trustworthy service.',
    avatar: '👩‍💼',
  },
  {
    name: 'Arjun Patel',
    location: 'Miyapur',
    rating: 5,
    text: 'I was impressed by the free moving support. The manpower coordination was smooth and professional. Will definitely use RoomBuddy again!',
    avatar: '👨‍💻',
  },
];
const NewTestimonials = () => {
  return (
    <section className="testimonials" id="testimonials">
      <div className="testimonials-container">
        <div className="testimonials-header">
          <span className="section-tag">Testimonials</span>
          <h2 className="section-title">What Our Customers Say</h2>
          <p className="section-subtitle">
            Real stories from real families who found their perfect home with RoomBuddy.
          </p>
        </div>
        <div className="testimonials-grid">
          {testimonials.map((t, index) => (
            <div className="testimonial-card" key={index}>
              <div className="testimonial-stars">
                {'★'.repeat(t.rating)}
              </div>
              <p className="testimonial-text">"{t.text}"</p>
              <div className="testimonial-author">
                <div className="testimonial-avatar">{t.avatar}</div>
                <div>
                  <div className="testimonial-name">{t.name}</div>
                  <div className="testimonial-location">📍 {t.location}</div>
                </div>
              </div>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
};
export default NewTestimonials;